import * as React from 'react';

import PropTypes from 'prop-types';

import {FunnelNumberLabel} from './funnel-number-label';

export class FunnelArrowDivider extends React.Component {
    static propTypes = {
        json: PropTypes.shape({
            count: PropTypes.shape({
                formatted: PropTypes.string.isRequired,
                suffix: PropTypes.string,
                percent: PropTypes.number,
            }).isRequired,
            amount: PropTypes.shape({
                formatted: PropTypes.string.isRequired,
                suffix: PropTypes.string,
                prefix: PropTypes.string,
                percent: PropTypes.number,
            }).isRequired,
        }).isRequired,
        displayType: PropTypes.oneOf(['count', 'amount']),
        isAdded: PropTypes.bool,
        isBlank: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        isAdded: false,
    };

    render() {
        return (
            <div className='ui-funnel-arrow-divider__arrow-container'>
                <div className='ui-funnel-arrow-divider__inner-arrow-container'>
                    {this.props.isAdded ? (
                        <div className='ui-funnel-section__arrow'>
                            <div className='ui-funnel-section__arrow-values'>
                                <FunnelNumberLabel
                                    json={this.props.json}
                                    isBlank={this.props.isBlank}
                                    displayType={this.props.displayType}
                                />
                            </div>
                            {this.props.isBlank ? undefined : (
                                <div className='ui-funnel-section__arrow-label'>
                                    <span>added</span>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className='ui-funnel-section__arrow'>
                            <div className='ui-funnel-section__arrow-values'>
                                {this.props.isBlank ? undefined : (
                                    <span className='ui-funnel-section__percent-text'>
                                        {this.props.json[this.props.displayType].percent}%
                                    </span>
                                )}
                                <FunnelNumberLabel
                                    json={this.props.json}
                                    isBlank={this.props.isBlank}
                                    displayType={this.props.displayType}
                                />
                            </div>
                            {this.props.isBlank ? undefined : (
                                <div className='ui-funnel-section__arrow-label'>
                                    <span>advanced</span>
                                </div>
                            )}
                        </div>
                    )}
                    <div className='ui-funnel-arrow-divider__chevron-container'>
                        <div className='ui-funnel-arrow-divider__chevron-background ui-funnel-arrow-divider__chevron-background--left' />
                        <div className='ui-funnel-arrow-divider__chevron-background ui-funnel-arrow-divider__chevron-background--right' />
                        <div className='ui-funnel-arrow-divider__chevron-border ui-funnel-arrow-divider__chevron-border--left' />
                        <div className='ui-funnel-arrow-divider__chevron-border ui-funnel-arrow-divider__chevron-border--right' />
                    </div>
                </div>
            </div>
        );
    }
}
